module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "padding": "1px 3px 1px 3px"
    }
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    ref: "search",
    staticClass: "no-border",
    staticStyle: {
      "padding": "8px",
      "border": "solid 0px #888",
      "color": "#666",
      "width": "100%",
      "font-size": "15px"
    },
    attrs: {
      "slot": "reference",
      "type": "text",
      "placeholder": "Search..."
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    },
    slot: "reference"
  })]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "1%"
    }
  }, [(_vm.searchMode) ? _c('v-btn', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.clearSearch
    }
  }, [_c('v-icon', {
    staticStyle: {
      "font-size": "18px"
    },
    attrs: {
      "color": "grey darken-1",
      "small": ""
    }
  }, [_vm._v("close")])], 1) : _c('GroupSelector', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "settings": {
        multiselect: false,
        title: 'Show Contacts for Group'
      }
    },
    on: {
      "select": _vm.groupSelected
    }
  })], 1)])])]), _vm._v(" "), _c('v-list', {
    staticStyle: {
      "padding-top": "0px",
      "border-radius": "6px"
    },
    attrs: {
      "two-line": ""
    }
  }, [_vm._l((_vm.contacts), function(contact, i) {
    return [_c('v-list-item', {
      key: contact.meta.tenantKey + '|' + contact.meta.key,
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.contactClicked(contact)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "padding-right": "10px"
      }
    }, [_c('ContactImage', {
      attrs: {
        "contact": contact,
        "size": 45
      }
    })], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("\n                " + _vm._s(_vm._f("fullName")(contact)) + "\n                "), (contact.partner) ? _c('span', {
      staticClass: "grey--text text--lighten-1"
    }, [_vm._v(" and " + _vm._s(contact.partner.firstName))]) : _vm._e()]), _vm._v(" "), _c('v-list-item-subtitle', {
      staticStyle: {
        "line-height": "1.5"
      }
    }, [(contact.preferredName) ? _c('div', {
      staticStyle: {
        "font-size": "11px",
        "background-color": "yellow",
        "display": "inline-block",
        "line-height": "0.9em"
      }
    }, [_vm._v("Prefer"), _c('br'), _vm._v(_vm._s(contact.preferredName))]) : _vm._e(), _vm._v("\n                " + _vm._s(_vm._f("phoneNumbers")(contact)) + " \n                "), _c('flag', {
      staticStyle: {
        "font-size": "12px"
      },
      attrs: {
        "value": _vm.initials(contact.owner),
        "title": _vm.officeNameFromKey(contact.meta.tenantKey)
      }
    }), _vm._v(" "), (contact.user) ? _c('flag', {
      staticStyle: {
        "font-size": "12px"
      },
      attrs: {
        "value": "User",
        "purple": "",
        "title": contact.meta.key
      }
    }) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.$listeners.jump) ? _c('ListJumpButton', {
      attrs: {
        "tooltip": "Jump to Latest Transaction"
      },
      on: {
        "click": function($event) {
          return _vm.jump(contact)
        }
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('v-divider', {
      key: 'd-' + i
    })]
  }), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "grey--text pa-3"
  }, [_c('v-progress-circular', {
    staticStyle: {
      "display": "block",
      "margin": "auto"
    },
    attrs: {
      "indeterminate": "",
      "color": "grey lighten-1"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.noResults) ? _c('v-list-item', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('add')
      }
    }
  }, [_c('v-list-item-avatar', [_c('v-icon', {
    staticClass: "grey--text text--lighten-2",
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("add_circle")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Add Contact")]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("No results. Add a new one?")])], 1)], 1) : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ceda94e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/ContactSearch.vue
// module id = 2568
// module chunks = 1